import React, { useState } from 'react';
import { ClasseDefWithUser } from '../../../../types/classe/classe.def';
import { FeatureClassManagerView } from './FeatureClassManager.view';
import {
  CSVEleveTypes,
  CSVEleveResultsTypes
} from '../../../../types/user/eleve.def';
import { useMutation, useQuery } from '@apollo/client';
import { ADD_ELEVE } from '../../../../graphql/mutation/user/eleve/eleve';
import { MESSAGES } from '../../../../helpers/messages';
import { eleveFormCSVParams } from '../../../../helpers/user/addEleveParams';
import { QueryUserClasseQuery } from '../../../../graphql/generated/graphql';
import { QUERY_USER_CLASSE } from '../../../../graphql/query/user/queryUserAccount';
import { ELEVE_ROLE, PROF_ROLE } from '../../../../helpers/user/authorization';
import { Modal } from 'components/organisms/Modals/Modal';
import { NotificationsEntry } from 'components/atoms/Notifications/NotificationsEntry';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import toast from 'react-hot-toast';
import { challengeRulesLink } from 'helpers/challenge';

interface ClasseState {
  open: { eleve: boolean; prof: boolean };
  disabled: boolean;
}

interface FeatureClassManagerProps {
  classe: ClasseDefWithUser;
}

export const FeatureClassManager = ({ classe }: FeatureClassManagerProps) => {
  const { data, loading: load, error } = useQuery<QueryUserClasseQuery>(
    QUERY_USER_CLASSE
  );

  const maClasse = data?.getUserClasse.id;

  const [feedback, setFeedback] = useState({
    messages: [],
    isOpen: false
  });

  const [createUser, { loading }] = useMutation(ADD_ELEVE, {
    onCompleted: () => {
      toast.success(MESSAGES.sucess.addUsers);
    }
  });

  const createAll = async eleves => {
    const elevesCreated = async (): Promise<any> =>
      eleves.map(async (eleve, i) => {
        let message;
        try {
          await createUser({
            variables: eleveFormCSVParams(eleve, maClasse)
          });
          message = MESSAGES.sucess.addUser(eleve.Nom);
        } catch (e) {
          message = MESSAGES.error.addUser(eleve.Nom, i);
        }
        return message;
      });

    const resultAll = await Promise.all(await elevesCreated());
    setFeedback({ messages: resultAll, isOpen: true });
    return resultAll;
  };

  const handleChange = async (results: CSVEleveResultsTypes) => {
    const eleves: CSVEleveTypes[] = results.data;
    await createAll(eleves);
  };

  const nbProf =
    classe?.users?.filter(user => user.role === PROF_ROLE)?.length || 0;
  const nbEleve =
    classe?.users?.filter(user => user.role === ELEVE_ROLE)?.length || 0;

  const [classeState, setClasseState] = useState<ClasseState>({
    open: { eleve: false, prof: false },
    disabled: false
  });

  const needHelp = () => {
    window.open(challengeRulesLink.book, '_blank');
  };

  const toggleOpen = type => {
    setClasseState({
      ...classeState,
      open: {
        ...classeState.open,
        [type]: !classeState.open[type]
      }
    });
  };

  if (loading || load)
    return <LoadingContainer variant="FeatureClassManager" />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération de la classe.')
        }
      />
    );
  return (
    <>
      <FeatureClassManagerView
        classe={classe}
        nbProf={nbProf}
        nbEleve={nbEleve}
        toggleOpen={toggleOpen}
        needHelp={needHelp}
        handleChange={handleChange}
      />
      {feedback.isOpen && (
        <Modal modalHead="Récapitulatif du fichier 📝" isShowingDefault={true}>
          {feedback.messages.map((message, i) => (
            <NotificationsEntry key={i} contentText={message} />
          ))}
        </Modal>
      )}
    </>
  );
};
